import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

const TRACE_ID_META_NAME = 'X-B3-TraceId';

/**
 * Reads the SSR request trace id from the `X-B3-TraceId` meta tag rendered by
 * SSR. Used as the `taskId` that correlates terminal events with the SSR
 * `taskStart` event.
 *
 * This is a plain reader — the decision of *whether* to attach the id (feature
 * gate, initial render, experience match) lives in `getCorrelatedTaskIdAttributes`.
 */
export const getInitialLoadTaskId = (): string | undefined =>
	getMeta(TRACE_ID_META_NAME) ?? undefined;
